import { render } from "./SkillComponent.vue?vue&type=template&id=6a206137"
import script from "./SkillComponent.vue?vue&type=script&lang=js"
export * from "./SkillComponent.vue?vue&type=script&lang=js"

import "./SkillComponent.vue?vue&type=style&index=0&id=6a206137&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__